const dobElementIds = ['__month', '__day', '__year', '__aumonth', '__auday', '__auyear'];

export default function isElementIncluded(id: string): boolean {
    return dobElementIds.some((element) => id.includes(element));
};